import React, { useEffect, useState } from 'react';
import styles from './subscription.module.scss';
import { Button, Container, Typography } from '@/ui-kit';
import { BadgePremium } from '@/components/badge-premium';
import { useGetTariffs } from '@/hooks/use-get-tariffs';
import { useGetInvoice } from '@/hooks/use-get-invoice';
import WebApp from '@twa-dev/sdk';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { routesApp } from '@/constans/routes';
import { PremiumList } from '@/components/premium-list';
import { useToast } from '@/store/useToast';
import { ErrorNotificationIcon } from '@/assets/icons';
import badgePriority from '@/assets/images/subscription/badge-priority.svg';
import { Tariff } from '@/types/tariff';
import { useVibration } from '@/store/useVibration';

export const Subscription: React.FC = () => {
    const { data } = useGetTariffs();
    const { mutateAsync: getInvoice, isPending } = useGetInvoice();
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const [tariffActiveId, setTariffActiveId] = useState(2);
    const showToast = useToast((state) => state.show);
    const handleClickSelectPremiumItem = (id: number) => {
        setTariffActiveId(id);
    };

    const { isVibrationEnabled } =
        useVibration(state => state);

    const handlePayment = async () => {
        if (!tariffActiveId) return;
        try {
            const data = await getInvoice(tariffActiveId);
            if (!data.data.ok) return;
            WebApp.openInvoice(data.data.result, (status) => {
                if (status === 'failed') {
                    throw new Error('Произошла ошибка оплаты попробуйте позже');
                }
                if (status === 'paid') {
                    navigate(routesApp.profile);
                    queryClient.invalidateQueries({ queryKey: ['profile'] });
                    if (isVibrationEnabled) {
                        WebApp
                            .HapticFeedback
                            .impactOccurred('medium');
                        // pass for not android
                        navigator.vibrate?.(10)
                    }
                }
            });
        } catch (error: any) {
            console.error(error);
            const message = error?.message || 'Ошибка. Попробуйте ещё раз';
            showToast({
                // type error
                icon: <ErrorNotificationIcon />,
                msg: message
            });
        }
    };

    const [sortedTariffs, setSortedTariffs] = useState<undefined | Tariff[]>(undefined)

    useEffect(() => {
        if (!data) return;
        setSortedTariffs(
            data
                .data
                .sort(
                    (a, b) =>
                        a.position - b.position
                )
        )
    }, [data])

    return (
        <section className={styles.section}>
            <div className={styles.wrapper}>
                <div className={styles.dekor}>
                    <div className={styles.dekorLight} />
                </div>
                <div className={styles.dekorHeart} />
                <div className={styles.info}>
                    <Typography
                        center
                        fontFamily="SFProDisplay"
                        fontWeight="bold"
                        className={styles.title}>
                        Euphora Premium
                    </Typography>
                    <Typography
                        center
                        fontFamily="SFProText"
                        className={styles.description}>
                        Больше матчей. Больше внимания. <br /> Больше знакомств
                    </Typography>
                </div>
                <PremiumList
                    tariffActiveId={tariffActiveId}
                    onChangeTariff={(id) => handleClickSelectPremiumItem(id)}
                    tariffs={sortedTariffs} />
                <Container className={styles.badgeContainer}>
                    <Typography
                        fontWeight="bold"
                        fontFamily="SFProText"
                        className={styles.badgeText}>
                        Станет доступно
                    </Typography>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 16,
                    }}>
                        <BadgePremium
                            description="Смотрите анкеты тех, кому вы понравились&nbsp;и&nbsp;отвечайте взаимностью" />
                        <BadgePremium
                            icon={badgePriority}
                            title="Повышенный приоритет"
                            description="Вашу анкету увидет больше пользователей" />
                    </div>
                    <Button
                        variant="stretched"
                        textColor="black"
                        className={styles.button}
                        isLoading={isPending}
                        onClick={handlePayment}>
                        Активировать Premium
                    </Button>
                </Container>
            </div>
        </section>
    );
};
